import Link from 'next/link';
import { Breadcrumb as BreadcrumbType } from 'shared/types/misc/Breadcrumb';
import BreadCrumbChevron from 'icons/breadcrumb-chevron';
import { cn } from 'helpers/utils/classnames';
import { gtmBreadcrumbClick } from 'helpers/utils/gtm-events/gtmInteraction';

interface BreadcrumbProps {
  className?: string;
  breadcrumbs: BreadcrumbType[];
  productName?: string;
  structuredData?: any;
}

const Breadcrumb = ({ breadcrumbs, productName, structuredData, className }: BreadcrumbProps) => {
  return (
    <>
      <section>
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
          ></script>
        )}
      </section>
      <nav aria-label="Breadcrumb" className={cn('mt-4 flex lg:mt-8', className)} data-testid="breadcrumbs">
        <ol className="flex flex-wrap items-center gap-2">
          <li className="flex items-center gap-2" aria-label="Home" data-testid="breadcrumb-home">
            <Link
              onClick={() => {
                gtmBreadcrumbClick('Home');
              }}
              href={'/'}
              className="text-xs"
            >
              Home
            </Link>
            <BreadCrumbChevron />
          </li>
          {breadcrumbs &&
            breadcrumbs.map((breadcrumb, index) => (
              <li
                key={'breadcrumb-' + index}
                className="flex items-center gap-2 text-xs"
                aria-label={breadcrumb.label}
                data-testid={'breadcrumb-' + breadcrumb.slug}
              >
                {breadcrumb.slug ? (
                  <Link
                    onClick={() => {
                      gtmBreadcrumbClick(
                        breadcrumb.label?.toLocaleLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) as string,
                      );
                    }}
                    href={breadcrumb.slug || ''}
                  >
                    {breadcrumb.label?.toLocaleLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
                  </Link>
                ) : (
                  <>{breadcrumb.label?.toLocaleLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}</>
                )}
                {index !== breadcrumbs.length - 1 && <BreadCrumbChevron />}
              </li>
            ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumb;
